var React = require('react');

function Blinds (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M96,226.94V160H16L0,256H66.94A47.82,47.82,0,0,1,96,226.94ZM16,416,0,512H512l-16-96ZM128,160v66.94A47.82,47.82,0,0,1,157.06,256H512l-16-96Zm29.06,128a47.73,47.73,0,0,1-90.12,0H16L0,384H512l-16-96ZM493.34,64H128v64H512ZM96,64H18.66L0,128H96Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M512,16V48a16,16,0,0,1-16,16H128V226.94a48,48,0,1,1-32,0V64H16A16,16,0,0,1,0,48V16A16,16,0,0,1,16,0H496A16,16,0,0,1,512,16Z","className":"fa-primary","key":2})]);
}

Blinds.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Blinds;

Blinds.default = Blinds;
